import { TourBuilderStoreEvents } from '../../events/TourBuilderStoreEvents';
import { TourBuilderStoreIoC } from '../../tourBuilderIoC';
import { TourBuilderStore } from '../../tourBuilderStore';
import { Scene, SceneGuid, SceneHelper } from '../../types/Scene';
import { SceneLink, SceneLinkGuid, SceneLinkHelper } from '../../types/SceneLink';
import { Position } from '@ael/core-api';

export type LinkTwoScenesUseCase = {
  newLinkGuid?: SceneLinkGuid;
  tourId: number;
  position: Position;
  destinationTourSceneGuid: SceneGuid;
};

export const linkTwoScenesUseCaseHandler = (
  params: LinkTwoScenesUseCase,
  getState: () => TourBuilderStore,
  services: TourBuilderStoreIoC,
  eventHandlers: TourBuilderStoreEvents
): Partial<TourBuilderStore> => {
  const store = getState();
  const scene = store.scenes.get(params.destinationTourSceneGuid);
  if (!scene) {
    return store;
  }

  const newLink = SceneLinkHelper.create(params.position, params.destinationTourSceneGuid, params.newLinkGuid);
  const updatedScene = SceneHelper.addNewLink(scene, newLink.guid);

  const newScenes = new Map<SceneGuid, Scene>(store.scenes);
  newScenes.set(updatedScene.guid, updatedScene);

  const newLinks = new Map<SceneLinkGuid, SceneLink>(store.links);
  newLinks.set(newLink.guid, newLink);

  void services.storageClient.createLink({
    tourSceneLinkGuid: newLink.guid,
    tourId: params.tourId,
    destinationTourSceneGuid: newLink.destinationTourSceneGuid,
    originTourSceneGuid: newLink.originTourSceneGuid,
    position: {
      sceneIndex: newLink.position.sceneIndex,
      xAxis: newLink.position.xAxis,
      yAxis: newLink.position.yAxis,
    },
  });

  eventHandlers.onLinkAdded.notify({
    guid: newLink.guid,
    sceneLink: newLink,
  });

  return {
    scenes: newScenes,
    links: newLinks,
  };
};
